import React from 'react'
import { useNavigate, Link } from 'react-router-dom'

const Footer = () => {
  const navigate = useNavigate()

  const handleStartTrial = () => {
    navigate('/signup')
  }

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container-padding">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/FlowBeatIQ-header_dark_bg.png" alt="FlowBeatIQ" className="h-12" />
            </div>
            <p className="text-gray-400 mb-6">
              Enterprise-level foot traffic insights built for small businesses.
            </p>
            <button
              onClick={handleStartTrial}
              className="bg-blue-600 text-white px-6 py-2 rounded-md font-semibold hover:bg-blue-700 transition-colors duration-200"
            >
              30-Day Risk-Free Trial
            </button>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="hover:text-white transition-colors duration-200"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="hover:text-white transition-colors duration-200"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('book-demo')}
                  className="hover:text-white transition-colors duration-200"
                >
                  Demo
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="hover:text-white transition-colors duration-200"
                >
                  Help Center
                </button>
              </li>
              <li><a href="mailto:support@flowbeatiq.com" className="hover:text-white transition-colors duration-200">support@flowbeatiq.com</a></li>
              <li><Link to="/setup-guide" className="hover:text-white transition-colors duration-200">Setup Guide</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/privacy" className="hover:text-white transition-colors duration-200">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors duration-200">Terms</Link></li>
              <li><Link to="/dpa" className="hover:text-white transition-colors duration-200">Data Processing</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; 2025 FlowBeatIQ. All rights reserved.</p>
          <p className="text-sm mt-2">FlowBeatIQ™ is a trademark of Rigel Labs LLC.</p>
          <p className="text-sm mt-1">Built in Austin, TX.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
